import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

import type { GapKeyword } from '@pepper/utils/src/types/seo'

export const getKeywordSuggestions = async ({
  reportId,
  companyId,
}: {
  reportId: string
  companyId: string
}): Promise<ApiResponseV2<GapKeyword[]>> => {
  try {
    const response = await axios.get(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/content-gap/${reportId}/keyword-suggestions`
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

// content-gap/5aeb2523-656a-47b6-bb94-7b577fc0c8c8/keyword-suggestions
